import Vue from 'vue';
import Vuex, { Payload, Store } from 'vuex';
import VuexPersist, { VuexPersistence } from 'vuex-persist';
import Cookies from 'js-cookie';

import AccountModule from '@/stores/AccountStore';
import QueueModule from '@/stores/QueueStore';
import FormModule from '@/stores/FormStore';
import BrancheModule from '@/stores/BranchesStore';
import LoginModule from '@/stores/LoginStore';

const PersistStorage = new VuexPersist({
  key: 'mobilecool-admin',
  storage: window.localStorage,
  modules: ['user'],
});

const vuexCookie = new VuexPersist({
  restoreState: (key: any) => Cookies.getJSON(key),
  saveState: (key: any, state: any) => {
    Cookies.set(key, state, {
      expires: 3,
    });
  },
  modules: ['mobilecool'],
});

Vue.use(Vuex);

export default new Vuex.Store({
  modules: { account: AccountModule, queue: QueueModule, form: FormModule, branche: BrancheModule, login: LoginModule },
  plugins: [PersistStorage.plugin, vuexCookie.plugin],
});
